const _require = require('../lib/evaluateSource'),
  combForSource = _require.combForSource,
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate ifAllBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return undefined;
  }
  const comb = await combForSource(source, content, parentContentPath, transientContext, nativeFunctions);
  return values.length > 0 && values.every(comb);
};
module.exports = {
  evaluate
};